import React, { Component } from 'react';
import { DateTime } from 'luxon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import CurrencyHelper from '../helpers/CurrencyHelper';
import StyleHelper from '../../shared/helpers/StyleHelper';
import FacilityHelper from '../helpers/FacilityHelper';

import './SlotPopover.css';
import { renderPricingBox } from '../../shared/components/PricingBox';
import PriceHelper from '../../shared/helpers/PriceHelper';
import styled from 'styled-components';
import { css } from 'styled-components';

class SlotPopover extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: [],
    };
    this.baseTop = 112;
  }

  onHide() {
    if (typeof this.props.onHide === 'function') {
      this.props.onHide();
    }
  }

  render() {
    const { facility, slot } = this.props;

    const branded = StyleHelper.applyCustomStyle(
      this.props.buttonStyle,
      '.SlotPopover .session-popover .sessionBody a.button.buttonBook.branded'
    )
      ? 'branded'
      : '';

    StyleHelper.applyCustomStyle(
      this.props.memberBookButtonStyle,
      '.SlotPopover .session-popover .sessionBody a.button.buttonBook.memberBook.branded'
    );
    const provider = facility['imin:dataSource'].identifier;

    // Session Times
    const startTimeString = DateTime.fromISO(slot.startDate).toLocaleString(
      DateTime.TIME_24_SIMPLE
    );
    let endTime = DateTime.fromISO(slot.endDate);
    if (endTime.second === 59) {
      endTime = endTime.plus({ seconds: 1 });
    }

    const endTimeString = endTime.toLocaleString(DateTime.TIME_24_SIMPLE);

    // Price
    const aggregateOffer = slot['imin:aggregateOffer'] || facility['imin:aggregateOffer'];
    const price = PriceHelper.getPricesList(aggregateOffer, provider);

    // Slot Book Buttons
    const slotBookSpaceObjects = FacilityHelper.slotBookSpaceObjects({
      slot,
      facilityUse: facility,
      baseCheckoutUrl: this.props.checkoutUrl,
      branded: branded,
      checkoutTheme: this.props.checkoutTheme,
      bookableProviders: this.props.bookableProviders,
      provider: provider,
      shouldShowBookAsGuestButton: this.props.shouldShowBookAsGuestButton,
      shouldShowBookAsMemberButton: this.props.shouldShowBookAsMemberButton,
      memberDeepLinks: this.props.memberDeepLinks,
      shouldShowNoAvailability: this.props.shouldShowNoAvailability,
    });
    const slotBookSpaceElements = slotBookSpaceObjects.map((obj, i) => {
      const TagName = obj.tag;
      const slotBookSpace = (
        <TagName className={obj.className} {...obj.attributes} key={`slotBookSpace-${i}`}>
          {obj.text}
        </TagName>
      );
      return slotBookSpace;
    });
    const BookButtonsWrapper =
      /** @type {import('styled-components').ThemedStyledFunction<'div', {isSessionPopover:boolean}>} */
      (styled.div)`
        display: flex;
        flex-direction: row;
        margin-bottom: 5px;
        width: max-content;
        margin-left: auto;
      `;
    const slotBookSpace = <BookButtonsWrapper>{slotBookSpaceElements}</BookButtonsWrapper>;

    // Session Availability
    let sessionAvailability;
    if (slotBookSpaceObjects[0] && slotBookSpaceObjects[0].availability) {
      sessionAvailability = (
        <span className="sessionAvailability">
          <strong>{slotBookSpaceObjects[0].availability}</strong>
        </span>
      );
    }

    return (
      <div className="SlotPopover">
        <div className="session-overlay" onClick={() => this.onHide()}></div>
        <div className="session-popover" style={{ top: `${this.baseTop + this.props.scrollY}px` }}>
          <div className="closePopover" onClick={() => this.onHide()}>
            <FontAwesomeIcon icon="times" />
          </div>
          <div className="sessionName">{facility.name}</div>
          <div className="sessionBody">
            <div className="sessionItem">
              <span className="sessionTimes">
                {startTimeString} - {endTimeString}
              </span>
              <span className="sessionDescription">
                {FacilityHelper.description(facility.description)}
              </span>
            </div>
            <div className="sessionItem">
              {slotBookSpace}
              {renderPricingBox(price, this.props.showPrices, true)}
              {!this.props.shouldShowNoAvailability && sessionAvailability}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SlotPopover.propTypes = {
  onHide: PropTypes.func,
  facility: PropTypes.object,
  slot: PropTypes.object,
  buttonStyle: PropTypes.object,
  memberBookButtonStyle: PropTypes.object,
  checkoutUrl: PropTypes.string,
  baseMemberBookUrl: PropTypes.string,
  checkoutTheme: PropTypes.string,
  bookableProviders: PropTypes.array,
  scrollY: PropTypes.number,
  shouldShowBookAsGuestButton: PropTypes.bool,
  shouldShowBookAsMemberButton: PropTypes.bool,
  memberDeepLinks: PropTypes.object,
  shouldShowNoAvailability: PropTypes.bool,
  showPrices: PropTypes.bool,
};

export default SlotPopover;
